import React from 'react';
import logo from '../asset/logo.png';
import { Link, useLocation } from 'react-router-dom';

const Header = ({ onLanguageChange, language }) => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  return (
    <header className="header">
      <div className="logo-container">
        <Link to={`/about?lang=${language}`}>
          <img src={logo} alt="Uni Studio" className="logo" />
        </Link>
        <span className="title">Uni Studio</span>
      </div>
      <div className="lang-toggle">
        <button
          onClick={() => onLanguageChange('en')}
          className={language === 'en' ? 'active' : ''}
        >
          EN
        </button>
        <button
          onClick={() => onLanguageChange('ko')}
          className={language === 'ko' ? 'active' : ''}
        >
          KR
        </button>
      </div>
    </header>
  );
}

export default Header;